import * as React from 'react';
import { ChangeEventHandler, LegacyRef } from 'react';
import cn from 'clsx';

import * as styles from './styles.css';
import { Typography } from '../../../Typography';
import { File, FileTypes } from '../../../File';
import { EAcceptedMimeTypes } from '../../../../containers/Uploader/constants';

export interface IEmptyContentProps {
  inputRef: LegacyRef<HTMLInputElement> | undefined;
  isShow: boolean;
  handleChange: ChangeEventHandler<HTMLInputElement>;
  dragActive?: boolean;
  isDisabled?: boolean;
  isMultiple?: boolean;
}

export const EmptyContent: React.FC<IEmptyContentProps> = ({
  handleChange,
  dragActive,
  isDisabled,
  inputRef,
  isShow,
  isMultiple = false,
}) => {
  const acceptFormats = Object.keys(EAcceptedMimeTypes)
    .map(value => `.${value}`)
    .join(', ');

  return (
    <label className={cn(styles.label, !isShow && styles.hide)}>
      <input
        type="file"
        ref={inputRef}
        disabled={isDisabled}
        className={styles.input}
        onChange={handleChange}
        accept={acceptFormats}
        multiple={isMultiple}
      />

      <div className={styles.content}>
        {dragActive && <Typography.Text level={4}>Поместите файл сюда</Typography.Text>}

        {!dragActive && (
          <>
            <div className={styles['file-icon']}>
              <File fileType={FileTypes.FILE} />
            </div>

            <div className={styles.text}>
              <Typography.Text level={4} color="link">
                Выбрать файлы
              </Typography.Text>

              <Typography.Text level={4}>или перетащить в эту область</Typography.Text>
              <Typography.Text level={6}>
                Формат и размер: {Object.keys(EAcceptedMimeTypes).join(', ')} до 10 Мбайт
              </Typography.Text>
            </div>
          </>
        )}
      </div>
    </label>
  );
};

EmptyContent.displayName = 'EmptyContent';
